import { t } from "@lingui/macro";
import { Button } from "@reactive-resume/ui";
import { useState } from "react";

import { isAnalyticsEnabled } from "@/client/libs/analytics";
import {
  applyConsent,
  getStoredConsent,
  setStoredConsent,
  type ConsentValue,
} from "@/client/libs/consent";

const PRIVACY_POLICY_URL = "https://resumotion.com/privacy-policy";

export const ConsentBanner = () => {
  const [isVisible, setIsVisible] = useState(
    () => isAnalyticsEnabled && getStoredConsent() === null,
  );

  if (!isVisible) return null;

  const onSelectConsent = (value: ConsentValue) => {
    setStoredConsent(value);
    applyConsent(value);
    setIsVisible(false);
  };

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 border-t bg-background/95 px-4 py-4 shadow-lg backdrop-blur print:hidden">
      <div className="mx-auto flex max-w-5xl flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="space-y-1">
          <p className="font-medium">{t`Cookie preferences`}</p>
          <p className="max-w-3xl text-sm text-secondary-foreground">
            {t`We use cookies and similar technologies to understand app usage and improve Resumotion.`}{" "}
            <a
              href={PRIVACY_POLICY_URL}
              target="_blank"
              rel="noreferrer"
              className="font-medium underline underline-offset-4"
            >
              {t`Privacy Policy`}
            </a>
          </p>
        </div>

        <div className="flex shrink-0 gap-2">
          <Button
            type="button"
            variant="secondary"
            onClick={() => {
              onSelectConsent("rejected");
            }}
          >
            {t`Decline`}
          </Button>
          <Button
            type="button"
            variant="primary"
            onClick={() => {
              onSelectConsent("accepted");
            }}
          >
            {t`Accept`}
          </Button>
        </div>
      </div>
    </div>
  );
};
